import React from 'react';

function UsersDomainPage() {
    return <div>Users Domain List Page</div>;
}

export default UsersDomainPage;
